export default __webpack_public_path__ + "static/media/iranyekanwebbold.11dc0ccb.svg";